module.exports = __webpack_public_path__ + "static/media/mcm1.059adf18.PNG";